import { useTranslation } from 'react-i18next'
import { Statistic, StatisticsBloc, SubStatistic } from './statistic.component'

type TGeneralStatisticNames =
  | 'patientCount'
  | 'programmedPatientMedEventCount'
  | 'smsSentCount'
  | 'unstartedFormRate'
  | 'invalidPatientPhoneRate'

type TGeneralStatistic = {
  name: TGeneralStatisticNames
  label: string
  value: string
  subStats?: TStatistic[]
}

type TStatistic = {
  name: string
  label: string
  value: string
  subStats?: TStatistic[]
}

const GeneralStatistics = ({ projectStatistics }: { projectStatistics: any }) => {
  const { t } = useTranslation()

  return (
    <>
      <h2 className="c-pb-2 c-text-base c-font-nexa c-font-semibold">
        {t('pages.statistics.general-statistics-title')}
      </h2>
      <StatisticsBloc>
        {projectStatistics?.generalStatistics?.map((generalStatistic: TGeneralStatistic) => {
          if (generalStatistic.name === 'patientCount') {
            return (
              <Statistic
                key={generalStatistic.name}
                label={t(`pages.statistics.${generalStatistic.name}`) || generalStatistic.name}
                value={generalStatistic.value}
              >
                {generalStatistic?.subStats?.map((subStat) => (
                  <SubStatistic key={subStat.name} label={subStat.label} value={subStat.value} />
                ))}
              </Statistic>
            )
          }
          return (
            <Statistic
              key={generalStatistic.name}
              label={t(`pages.statistics.${generalStatistic.name}`) || generalStatistic.name}
              value={generalStatistic.value}
            />
          )
        })}
      </StatisticsBloc>
    </>
  )
}

export { GeneralStatistics }
